import React, { useEffect, useState } from "react";
import { getContentById } from "../../API/content";
import "./CalendarPageModal.css";

export default function CalendarPageModal() {
  const [calendarData, setCalendarData] = useState(null);
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const date = new Date();
    const data = await getContentById("calendarPageModel");
    let filteredData = data;
    filteredData = filteredData.filter((data) => new Date(data.date) > date);
    setCalendarData(filteredData);
  };

  return (
    <div className="CalendarPageModal">
      <div className="calendarBody">
        <div className="left-body">
          <h2>Claremont Mosque's</h2>
          <br />
          <h1>Calendar Page Model</h1>
          <br />
          <hr />
          {calendarData?.map((data) => (
            <div className="page-model-container" key={data.id}>
              <div className="model-left">
                <p>• {data.date}</p>
              </div>
              <div className="model-right">
                <p>{data.description}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="right-body">
          <img src="assets/Rectangle 25.png" alt="" />
          <img src="assets/Rectangle 27.png" alt="" />
          <img src="assets/Rectangle 26.png" alt="" />
        </div>
      </div>
    </div>
  );
}
